export const ENTITY_TYPE = "UNIT_PLAN";

export const INITIAL_STATE = {
  DIALOG_ACTION: {
    action: "",
    params: {
      isChecked: false,
    },
  },
  EDIT_USER_PROMPT_OBJ: {
    isEditMode: false,
    userPrompt: "",
  },
};

export const SHOW_STARTER_PROMPTS_PERM = "FeatureFlag:ShowUnitAIStarterPrompts";
export const SUBJECT_REQUIREMENT_PERM =
  "FeatureFlag:UnitPlanAISubjectRequirement";
export const SHOW_DELETE_BUTTON_PERM = "FeatureFlag:EnableDeleteForUnitAI";

export const MAX_RETRIES = 3;
